import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";

import { merchantApi } from "@api";
import { PATH_MEMBER_TYPE } from "@configs";
import { IGroupType } from "@interfaces";
import { selectAuth, selectMerchant } from "@redux";
import { RenderMeta, useNotify } from "@utils";
import { useTranslation } from "react-i18next";
import { BackIcon } from "src/Components/icon/TopSpender/BackIcon";
import styled from "styled-components";

export const PageMemberType = () => {
    //page hook
    const history = useHistory();
    const dispatch = useDispatch();
    //page redux

    const { gLink } = useParams<{ gLink: string }>();
    const { userInfo } = useSelector(selectAuth);
    const { themes, memberShipTiers } = useSelector(selectMerchant);
    const { t } = useTranslation();
    const { success, error, warning } = useNotify();

    useEffect(() => {
        if (gLink) {
            getTypeList();
        }
    }, [gLink]);
    const [groupDetail, setGroupDetail] = useState<IGroupType>();

    const getTypeList = async () => {
        let res = await merchantApi.getMemberType();
        if (res.data?.result?.MemberTypeConfig?.isMemberApply) {
            let findObj = res.data?.result?.MemberTypeConfig?.memberTypeGroupName.find(
                (item: any) => item.typeGroupNameUrlPath === "/" + gLink
            );
            if (findObj !== undefined) {
                setGroupDetail(findObj);
            } else {
                warning("Don't have this group");
            }
        }
    };

    const clickType = (typeUrl: string) => {
        history.push(PATH_MEMBER_TYPE + "/" + gLink + typeUrl);
    };

    const clickBack = () => {
        history.push(PATH_MEMBER_TYPE);
    };

    return (
        <StyledTypePage themeColor={themes?.themeColor!}>
            <RenderMeta title={t("meta.membertype_page")} />
            <div className="layout-back" onClick={clickBack}>
                <BackIcon color={themes?.themeColor!} />
                <h1>{t("page.card.select_member")}</h1>
            </div>
            <div className="list-section">
                {groupDetail?.typeGroupNameList?.map((tItem, tIndex) => {
                    return (
                        <div
                            className="list-item"
                            key={tIndex}
                            onClick={() => clickType(tItem?.typeNameUrlPath)}
                        >
                            {/* {tItem?.typeName} */}
                            <img src={tItem?.typeNameIcon} alt="img" />
                        </div>
                    );
                })}
            </div>
        </StyledTypePage>
    );
};

const StyledTypePage = styled.div<{ themeColor: string }>`
    padding: 20px;
    height: 100vh;
    position: relative;
    background-color: #fff;
    .layout-back {
        position: absolute;
        left: 20px;
        top: 20px;
        display: flex;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: right;
        width: calc(100% - 32px);
    }
    h1 {
        font-size: 20px;
        line-height: 24px;
        font-weight: 600;
        color: ${(p) => p.themeColor};
        margin-bottom: 0;
    }
    .list-section {
        margin: 20px 0;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 20px;
        margin-top: 52px;
        .list-item {
            cursor: pointer;
            border-radius: 20px;
            height: 120px;
            background-color: #ddd;
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }
    }
`;
